module.exports = __webpack_public_path__ + "img/main-data-ioc01.d41af266.png";